module.exports = __webpack_public_path__ + "img/social-new-1.eccfd4c.jpg";